import { IProduct } from '../types';

export const getUniqueProducts = (products: IProduct[]) => {
  const uniqueProducts: IProduct[] = [];
  products.forEach((product) => {
    const productExists = uniqueProducts.find(
      (uniqueProduct) => uniqueProduct.id === product.id,
    );
    if (!productExists) {
      uniqueProducts.push(product);
    }
  });
  return uniqueProducts;
};
